import React from "react";
import { Button, ViewCardIcon, ViewLineIcon } from "@pd/pd-ui-kit";
import s from "./s.less";
import { useHistory } from "react-router-dom";

interface CameraTitleButtonGroupIProps {
  showImages: boolean;
  toggleShowImages: () => void;
  currentDealerId: string;
}

const CameraTitleButtonGroup = ({
  showImages,
  toggleShowImages,
  currentDealerId,
}: CameraTitleButtonGroupIProps) => {
  const history = useHistory();

  const goHistoryCameraList = () => {
    const url = `/ivideon/cameras/history/${currentDealerId}`;
    window.open(url, "_blank");
  };
  return (
    <div className={s.wrapperButtonGroup}>
      <div className={s.wrapperIcons}>
        <span>Смотреть камеры:</span>
        <div className={s.icons} onClick={toggleShowImages}>
          <Button
            color="secondary"
            variant={showImages ? "default" : "filled"}
            size="middle"
            icon={
              <ViewLineIcon
                style={{ color: showImages ? "#ffffff" : "#848E98" }}
              />
            }
          />
          <Button
            color="secondary"
            variant={showImages ? "filled" : "default"}
            size="middle"
            icon={
              <ViewCardIcon
                style={{ color: showImages ? "#848E98" : "#ffffff" }}
              />
            }
          />
        </div>
      </div>
      <Button
        color="secondary"
        size="middle"
        fontSize="12"
        onClick={goHistoryCameraList}
      >
        История по всем камерам
      </Button>
    </div>
  );
};

export default CameraTitleButtonGroup;
